import React from 'react'


function Education() {
    return (
        <div className='container my-5 ' style={{paddingLeft: "9rem"}} >
            <div className='row'>
                <div className='col-5' style={{ marginRight: "7rem"}}>
                    <img src='media/education.svg' style={{ width: '100%'}} alt='eduloggo'/>
                </div>
                <div className='col-5' style={{ marginTop: "5rem"}}>
                    <h3>Free and open market education</h3> <br/>
                    <p>Varsity, the largest online stock market education book in the world covering everything from the basics to advanced trading.</p>
                    <div>
                        <a href='' className='mx-2' style={{ textDecoration: "none" }}>Varsity</a>
                        <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                    </div><br/>

                    <p>TradingQ&A, the most active trading and investment community in India for all your market related queries.</p>
                    <div>
                        <a href='' className='mx-2' style={{ textDecoration: "none" }}>TradingQ&A</a>
                        <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Education;